import json from './sounds.json';
import { SoundCategory } from './soundCategory';

class SoundLibrary {
  categories: SoundCategory[];
  private categoriesByName: Map<string, SoundCategory>;

  constructor() {
    this.categories = Object.entries(json).map(([name, data]) => new SoundCategory(name, data));
    this.categoriesByName = new Map(this.categories.map(category => [category.name, category]));
  }

  getCategory(name: string): SoundCategory | undefined {
    return this.categoriesByName.get(name);
  }
}

export default new SoundLibrary();
